import { LivestreamConfigurationService } from '~/ng-services/livestreams/LivestreamConfiguration.service';

(function () {
    const template = `
        <div class="ty-video-conference-app" ng-class="{ 'is-chat-open': $ctrl.isChatVisible }">
            <div class="conference-video" id="{{$ctrl.jitsiFrameID}}"></div>
            <div
                ng-if="$ctrl.enableChat && chatv2enabled"
                class="conference-chat"
                open-chat-handler elastic-widget=""
                elastic-widget-offset="#head:#foot"
            >
                <div class="chat_close" ng-if="$ctrl.isChatVisible">
                    <button class="chat_close__button" type="button" ng-click="$ctrl.isChatVisible = false">
                        <i class="fa fa-times"></i>
                    </button>
                </div>
                <ty-chat/>
            </div>
            <div class="conference-chat" ng-if="$ctrl.enableChat && !chatv2enabled">
                <iframe class="conference-chat__frame" ng-src="{{$ctrl.chatFrameUrl}}"></iframe>
            </div>
        </div>
    `;

    angular.module('tradersyard').component('tyVideoConferenceApp', {
        template,
        bindings: {
            /**
             * ID of the meeting in TradersYard - this is seen as a chatroom on the page.
             * For example, the meeting ID created for https://tradersyard.com/group/240 is 1581.
             */
            meetingId: '<',
            enableChat: '<',
            closeWindowOnHangup: '<',
            disableHangupButton: '<',
            /**
             * Executed when conference is about to be closed. Executed as soon as you click "Hangup" button.
             */
            onHangup: '&',
            onLeftAlone: '&',
        },
        controller: VideoConferenceAppCtrl,
    });

    VideoConferenceAppCtrl.$inject = [
        '$q',
        '$interval',
        'MeetingService',
        'LivestreamConfigurationService',
        'graph-meeting-factory',
        '$element',
        '$sce',
        '$window',
        '$scope',
    ];

    /**
     *
     * @param {angular.IQService} $q
     * @param {angular.IIntervalService} $interval
     * @param {MeetingService} MeetingService
     * @param {LivestreamConfigurationService} LivestreamConfigurationService
     * @param {graph-meeting-factory} meetingApi
     * @param {angular.IRootElementService} $element
     * @param {angular.ISCEService} $sce
     * @param {angular.IWindowService} $window
     * @param {angular.IScope} $scope
     * @constructor
     */
    function VideoConferenceAppCtrl(
        $q,
        $interval,
        MeetingService,
        LivestreamConfigurationService,
        meetingApi,
        $element,
        $sce,
        $window,
        $scope
    ) {
        const ctrl = this;

        $scope.chatv2enabled = featureEnabled('chatv2');

        ctrl.isChatVisible = window.innerWidth > 768;

        /**
         * @type {JitsiMeetExternalAPI}
         */
        let jitsi;

        /**
         * @type {{roomName: string, id: string, displayName: string, avatarURL: string}}
         */
        let _localParticipant;

        // region: public

        ctrl.jitsiFrameID = 'conference-iframe-wrapper';

        /**
         * URL of the meeting chat that will be loaded into iframe.
         * @see $onInit
         * @type {string}
         */
        ctrl.chatFrameUrl = '';

        ctrl.$onInit = () => $onInit();
        ctrl.$onDestroy = $onDestroy;

        /**
         * @var {'ERR_NONE' | 'ERR_CANNOT_LOAD'}
         */
        ctrl.error = 'ERR_NONE';

        // endregion: public
        async function $onInit() {
            ctrl.chatFrameUrl = $sce.trustAsResourceUrl(`/meeting/${ctrl.meetingId}?webview&conversations`);

            try {
                const connectOptions = await meetingApi.getVideoConferenceConnectOptions(ctrl.meetingId);
                _ensureJitsiParentNodeExists().then(() => _initializeConferenceVideo(connectOptions));
            } catch (e) {
                ctrl.error = 'ERR_CANNOT_LOAD';
            }

            // Make sure we dispose of jitsi. I have no idea if Angular runs $onDestroy during beforeunload event
            _onWindowClosed(() => $onDestroy());
        }

        function $onDestroy() {
            console.log('$onDestroy - disposing of Jitsi');
            jitsi?.dispose();
        }

        // region: private methods

        // this is a hotfix for a race condition
        function _ensureJitsiParentNodeExists() {
            return new Promise((resolve) => {
                const interval = setInterval(() => {
                    const parentNode = _getJitsiParentNode();

                    if (!parentNode) {
                        console.warn('Jitsi parent node doesnt exist', parentNode);
                        return;
                    }

                    clearInterval(interval);
                    resolve(parentNode);
                }, 30);
            });
        }

        /**
         *
         * @param {ApiVideoConferenceConnectOptions} connectOptions
         * @private
         */
        function _initializeConferenceVideo(connectOptions) {
            console.log('Initializing Conference Video Frame');

            const { entry, entry_id } = connectOptions;
            const streamingKey = LivestreamConfigurationService.getStreamingKey({ entry, entry_id });

            if (streamingKey) {
                console.log('Retrieved Streaming Key', streamingKey);
            }

            const options = {
                ...connectOptions,
                configOverwrite: {
                    ...(connectOptions.configOverwrite || {}),
                    liveStreamingStreamKey: streamingKey,
                    startWithVideoMuted: true, //disable video by default
                    startWithAudioMuted: false, //disable audio by default
                    buttonsWithNotifyClick: ['chat'], //makes the chat button send us events instead of toggling jitsi chat
                },
                // This will append the iframe to the `parentNode`
                // todo: this is a race condition. The parentNode might not exist yet.
                parentNode: _getJitsiParentNode(),
                interfaceConfigOverwrite: {
                    ...(connectOptions.interfaceConfigOverwrite || {}),
                    EXTERNAL_CHAT_ENABLED: true,
                    EXTERNAL_FULLSCREEN_ENABLED: true,
                    HANGUP_BUTTON_ENABLED: !ctrl.disableHangupButton,
                },
                width: '100%',
                height: '100%',
            };

            _maybeJitsiMeetExternalAPI(connectOptions.host, options)
                .then((jitsi) => {
                    console.log('JitsiMeetExternalAPI received. Setting up events.');
                    _setupJitsiMeetExternalAPI(jitsi);
                })
                .catch((err) => console.warn(err));
        }

        /**
         * Mechanism for pushing various flags to Choop.
         * @param flag Flag name
         * @param state Flag state
         */
        function setJitsiExternalFlag(flag, state) {
            // this seems to be removed in jaas release 4620
            // [TY-2377] JaaS - p2p call is broken when user tries to call
            return;

            $window.JITSI_API._transport.sendEvent({
                name: 'notify-external-flag-changed',
                data: [flag, state],
            });
        }

        function _setupJitsiMeetExternalAPI(jitsi) {
            // expose on global scope so it can be accessed by AgenaTrader and xTasyTrader
            $window.JITSI_API = jitsi;

            const fullscreenElement = document.documentElement;

            // If external fullscreen support is enabled, the external API must notify choop whether
            // fullscreen is enabled, so that it can update its UI appropriately.
            fullscreenElement.addEventListener('fullscreenchange', () => {
                jitsi._transport.sendEvent({
                    name: 'notify-external-fullscreen-state',
                    data: [!!document.fullscreenElement],
                });
            });

            // todo: add event handler to jitsi external_api.js
            jitsi._transport.on('event', function ({ name, ...data }) {
                // If external fullscreen support is enabled in interface config, enabling fullscreen
                // will instead notify external APi (this code). We must then launch/disable fullscreen mode here.
                if (name === 'choop-set-external-fullscreen-state') {
                    if (data.enabled) {
                        fullscreenElement.requestFullscreen();
                    } else {
                        document.exitFullscreen();
                    }
                }

                // Events for when a toolbar button was clicked in Choop.
                // Only buttons designated in init config above (buttonsWithNotifyClick) will send events.
                // This also stops them from performing their default actions in Choop.
                // An overridden button's active state must also be tracked somewhere here, and sent to
                // Choop as external flags.
                if (name === 'toolbar-button-clicked') {
                    switch (data.key) {
                        case 'chat':
                            $scope.$apply(function () {
                                // Toggle TY chat visibility
                                ctrl.isChatVisible = !ctrl.isChatVisible;

                                // Tell Choop what state the chat is in so that it can render
                                // active/inactive state on chat button properly
                                setJitsiExternalFlag('externalChatOpen', ctrl.isChatVisible);
                            });
                            break;
                    }
                }
            });

            // keep track of local participant info - we need this to detect if you are the only person left
            // and then close the window.
            jitsi.on('videoConferenceJoined', (localParticipantData) => {
                _localParticipant = localParticipantData;
                console.log('Video Conference - Conference Joined as:', _localParticipant);
            });

            jitsi.on('readyToClose', () => {
                console.log('Video Conference - Ready to Close');
                ctrl.onHangup && ctrl.onHangup();

                if (ctrl.closeWindowOnHangup) {
                    $window.close();
                }
            });

            // Listen for participants leaving.
            // Detect whether or not you are the only one left.
            // NOTE: this event is fired even if YOU are the one who's leaving.
            //       It will fire for each participant that YOU are leaving.
            jitsi.on('participantLeft', (participant) => {
                console.log('Video Conference - Participant Left', participant);

                const remainingCount = jitsi.getNumberOfParticipants();

                // if you are the only one left, this event gets fired.
                // We need to exclude local participant, because the participantLeft even't is also fired for him.
                if (_localParticipant.id !== participant.id && remainingCount === 1) {
                    console.log('Video Conference - Left Alone', jitsi);
                    ctrl.onLeftAlone && ctrl.onLeftAlone();
                }
            });

            // Send initial chat state
            setJitsiExternalFlag('externalChatOpen', $scope.isChatVisible);
        }

        /**
         * Tries to instantiate JitsiMeetExternalAPI for a few seconds then bails.
         * This is needed because the external_api.js script might take some time to load.
         *
         * @private
         */
        function _maybeJitsiMeetExternalAPI(host, options) {
            const deferred = $q.defer();
            const makeJitsi = () => new JitsiMeetExternalAPI(host, options);

            // see if we already have it
            if (window.JitsiMeetExternalAPI) {
                console.log('JitsiMeetExternalAPI already here. Making an instance now.');
                return $q.resolve(makeJitsi());
            } else {
                console.warn('JitsiMeetExternalAPI is not here. Will try again in a moment.');
            }

            // otherwise we will try a few more times
            const keepTryingPromise = $interval(
                () => {
                    console.log('Trying to create JitsiMeetExternalAPI again...');
                    if (window.JitsiMeetExternalAPI) {
                        deferred.resolve(makeJitsi());
                        $interval.cancel(keepTryingPromise);
                    }
                },
                1000,
                10,
                false
            );

            keepTryingPromise
                .then(() => deferred.reject('JitsiMeetExternalAPI is not defined and could not be instantiated.'))
                .catch(() => console.log('JitsiMeetExternalAPI created. Interval canceled.'));

            return deferred.promise;
        }

        function _getJitsiParentNode() {
            return $element.find(`#${ctrl.jitsiFrameID}`)[0];
        }

        function _onWindowClosed(callback) {
            $window.addEventListener('beforeunload', callback);
        }

        // endregion: private methods
    }
})();
